import { createColumnInput } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { onClickDeleteAllClient } from '../../../../../utils/form';
import { createLoading } from '../../../../../utils/loading';
import { has } from "../../../../../utils/menu-context";
import { createManageDelete, createPage } from '../../../../../utils/page';
import lodash from 'lodash'
import { openModalList } from "../../../company/company/company.logic";
import { onIFrameClickSelectAll } from "../../../../../utils/iframe";

export const { isLoading, setIsLoading } = createLoading()

export const callConfirmStatusByKey = ({ key }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CONFIRM_STATUS', key })
export const callUserOperatorStatusByKey = ({ key }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'USER_OPERATOR', key })

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.company.thNo"), dataIndex: "refCompany.thNo" }),
        createColumnInput({ title: () => i18n.global.t("model.company.nameTh"), dataIndex: "refCompany.nameTh", width: 200 }),
        createColumnInput({ title: () => i18n.global.t("model.company.nameEn"), dataIndex: "refCompany.nameEn", width: 200 }),
    ]
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleCompany } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    data.columns = createColumns({ props, data })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => viewOnly ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey })
        }),
    ]
    data.manageExtras = []
    data.rowActions = []
    if (!viewOnly) {
        if (visibleCompany) {
            /*
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalListCompany({
                            onIframeMounted: ({ refs, options }) => onIFrameClickSelectAll({
                                refs, options, items, itemKey: 'refCompany.id', rowKey: 'id', setKey: 'refCompany'
                            }),
                        }),
                        options: { text: i18n.global.t('model.companyCountry.refCompany') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })
            */
        }
        if (visibleCompany) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalList({
                            onIframeMounted: ({ refs, options }) => {
                                onIFrameClickSelectAll({
                                    refs, options, items, itemKey: 'refCompany.id', rowKey: 'refCompany.id', getKey: 'refCompany', setKey: 'refCompany',
                                    afterSelect: () => {
                                        Promise.all([callConfirmStatusByKey({ key: 'Approve' }), callUserOperatorStatusByKey({ key: '2' })])
                                            .then(res => {
                                                const statusDraft = res[0][0];
                                                const userOperator = res[1][0];
                                                    items.forEach(item => {
                                                        if (!item.refApproveStatus) {
                                                            item.refApproveStatus = statusDraft
                                                            item.isApproveRegister = true
                                                            item.refUserOperator = userOperator
                                                        }
                                                    })
                                            })
                                    }
                                })
                            },
                        }),
                        options: { text: i18n.global.t('model.company.modelName') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })
        }
    }
}
//
// export const onIFrameClickSelectAll = ({ refs, options, items, itemKey, rowKey, setKey, afterSelect }) => {
//     refs.iframe.contentWindow.onSearch = ({ page }) => {
//         const defaultOnSearch = () => {
//             const value = items.filter(d => d.isDelete !== true).map(d => lodash.get(d, itemKey))
//             if (value.length > 0) {
//                 page.where.push({ name: rowKey, type: 'UUID', operator: '!in', value })
//             }
//         }
//         defaultOnSearch()
//     }
//     refs.iframe.contentWindow.onSelect = ({ rowSelection }) => {
//         const itemsPush = []
//         rowSelection.selectedRows.forEach(row => {
//             row = "id" != rowKey? row[setKey] : row
//             let item = items.find(d => lodash.get(d, itemKey) === lodash.get(row, rowKey))
//             if (item) {
//                 item.isActive = true
//                 item.isDelete = false
//                 lodash.set(item, setKey, row)
//             } else {
//                 item = { isSave: true }
//                 if (setKey) {
//                     lodash.set(item, setKey, row)
//                 } else {
//                     lodash.assign(item, row)
//                 }
//                 itemsPush.push(item)
//             }
//         })
//         items.push(...itemsPush)
//         afterSelect?.({ rowSelection })
//         options.bind.onCancel()
//     }
// }